import { Encipher } from './encipher';

export class Key {
    id: number;
    keyValue: string;
    encipher: Encipher;
}